import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/abank24';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false,
            activeContent: ''
        };
        this.setActiveContent = this.setActiveContent.bind(this);

        return this;
    }
    componentDidMount() {
        setInterval(this.changeMode, 8000);
    }
    setActiveContent = item => {
        this.setState({activeContent: item});
    };

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }
}
